export default "__VITE_ASSET__2d64b795__"